import type * as core from '../../../../../../../core'

/* eslint-disable sort-keys */

export const query: core.mosaic.Widget.Query = {
  selection: {
    '{}': {
      name: 'Comparative Performance',
      type: 'charts',
      content: {
        '{}': {
          data: {
            '[]': [
              {
                '{}': {
                  name: 'Total ($MM)',
                  values: {
                    if: [
                      [
                        {
                          not: {
                            '=': [
                              {
                                '@$': 'piRecordId',
                              },
                              null,
                            ],
                          },
                        },
                        {
                          '[]': [
                            {
                              '{}': {
                                name: {
                                  '@': 'piName',
                                },
                                points: {
                                  '[]': [
                                    {
                                      '{}': {
                                        x: '2023',
                                        y: {
                                          '+': {
                                            '->': [
                                              {
                                                '@': '2023_Pis',
                                              },
                                              {
                                                '@>': [
                                                  {
                                                    '@$': '$value',
                                                  },
                                                  'selectedPiProjectsExpenses',
                                                ],
                                              },
                                            ],
                                          },
                                        },
                                      },
                                    },
                                    {
                                      '{}': {
                                        x: '2024',
                                        y: {
                                          '+': {
                                            '->': [
                                              {
                                                '@': '2024_Pis',
                                              },
                                              {
                                                '@>': [
                                                  {
                                                    '@$': '$value',
                                                  },
                                                  'selectedPiProjectsExpenses',
                                                ],
                                              },
                                            ],
                                          },
                                        },
                                      },
                                    },
                                  ],
                                },
                              },
                            },
                            {
                              '{}': {
                                name: 'Average across all PIs',
                                points: {
                                  '[]': [
                                    {
                                      '{}': {
                                        x: '2023',
                                        y: {
                                          '/': [
                                            {
                                              '+': {
                                                '->': [
                                                  {
                                                    '@': '2023_Pis',
                                                  },
                                                  {
                                                    '@>': [
                                                      {
                                                        '@$': '$value',
                                                      },
                                                      'projectsExpenses',
                                                    ],
                                                  },
                                                ],
                                              },
                                            },
                                            {
                                              '#': {
                                                '@': '2023_Pis',
                                              },
                                            },
                                          ],
                                        },
                                      },
                                    },
                                    {
                                      '{}': {
                                        x: '2024',
                                        y: {
                                          '/': [
                                            {
                                              '+': {
                                                '->': [
                                                  {
                                                    '@': '2024_Pis',
                                                  },
                                                  {
                                                    '@>': [
                                                      {
                                                        '@$': '$value',
                                                      },
                                                      'projectsExpenses',
                                                    ],
                                                  },
                                                ],
                                              },
                                            },
                                            {
                                              '#': {
                                                '@': '2024_Pis',
                                              },
                                            },
                                          ],
                                        },
                                      },
                                    },
                                  ],
                                },
                              },
                            },
                          ],
                        },
                      ],
                      [
                        {
                          and: [
                            {
                              not: {
                                '=': [
                                  {
                                    '@$': 'orgRecordId',
                                  },
                                  null,
                                ],
                              },
                            },
                            {
                              not: {
                                '=': [
                                  {
                                    '@$': 'orgEntityId',
                                  },
                                  null,
                                ],
                              },
                            },
                          ],
                        },
                        {
                          '[]': [
                            {
                              '{}': {
                                name: {
                                  '@': 'orgName',
                                },
                                points: {
                                  '[]': [
                                    {
                                      '{}': {
                                        x: '2023',
                                        y: {
                                          '+': {
                                            '->': [
                                              {
                                                '@': '2023_orgs',
                                              },
                                              {
                                                '@>': [
                                                  {
                                                    '@$': '$value',
                                                  },
                                                  'selectedOrgProjectsExpenses',
                                                ],
                                              },
                                            ],
                                          },
                                        },
                                      },
                                    },
                                    {
                                      '{}': {
                                        x: '2024',
                                        y: {
                                          '+': {
                                            '->': [
                                              {
                                                '@': '2024_orgs',
                                              },
                                              {
                                                '@>': [
                                                  {
                                                    '@$': '$value',
                                                  },
                                                  'selectedOrgProjectsExpenses',
                                                ],
                                              },
                                            ],
                                          },
                                        },
                                      },
                                    },
                                  ],
                                },
                              },
                            },
                            {
                              '{}': {
                                name: 'Average across all Organizations',
                                points: {
                                  '[]': [
                                    {
                                      '{}': {
                                        x: '2023',
                                        y: {
                                          '/': [
                                            {
                                              '+': {
                                                '->': [
                                                  {
                                                    '@': '2023_orgs',
                                                  },
                                                  {
                                                    '@>': [
                                                      {
                                                        '@$': '$value',
                                                      },
                                                      'projectsExpenses',
                                                    ],
                                                  },
                                                ],
                                              },
                                            },
                                            {
                                              '#': {
                                                '@': '2023_orgs',
                                              },
                                            },
                                          ],
                                        },
                                      },
                                    },
                                    {
                                      '{}': {
                                        x: '2024',
                                        y: {
                                          '/': [
                                            {
                                              '+': {
                                                '->': [
                                                  {
                                                    '@': '2024_orgs',
                                                  },
                                                  {
                                                    '@>': [
                                                      {
                                                        '@$': '$value',
                                                      },
                                                      'projectsExpenses',
                                                    ],
                                                  },
                                                ],
                                              },
                                            },
                                            {
                                              '#': {
                                                '@': '2024_orgs',
                                              },
                                            },
                                          ],
                                        },
                                      },
                                    },
                                  ],
                                },
                              },
                            },
                          ],
                        },
                      ],
                      {
                        '[]': [
                          {
                            '{}': {
                              name: '',
                              points: {
                                '[]': [
                                  {
                                    '{}': {
                                      x: '2023',
                                      y: {
                                        '+': {
                                          '->': [
                                            {
                                              '@': '2023_projectsGlExpenses',
                                            },
                                            {
                                              '@>': [
                                                {
                                                  '@$': '$value',
                                                },
                                                {
                                                  if: [
                                                    [
                                                      {
                                                        '=': [
                                                          {
                                                            '@$': 'financialVolume',
                                                          },
                                                          'MTDC',
                                                        ],
                                                      },
                                                      'mtdcAmount',
                                                    ],
                                                    'tdcAmount',
                                                  ],
                                                },
                                              ],
                                            },
                                          ],
                                        },
                                      },
                                    },
                                  },
                                  {
                                    '{}': {
                                      x: '2024',
                                      y: {
                                        '+': {
                                          '->': [
                                            {
                                              '@': '2024_projectsGlExpenses',
                                            },
                                            {
                                              '@>': [
                                                {
                                                  '@$': '$value',
                                                },
                                                {
                                                  if: [
                                                    [
                                                      {
                                                        '=': [
                                                          {
                                                            '@$': 'financialVolume',
                                                          },
                                                          'MTDC',
                                                        ],
                                                      },
                                                      'mtdcAmount',
                                                    ],
                                                    'tdcAmount',
                                                  ],
                                                },
                                              ],
                                            },
                                          ],
                                        },
                                      },
                                    },
                                  },
                                ],
                              },
                            },
                          },
                        ],
                      },
                    ],
                  },
                },
              },
              {
                '{}': {
                  name: 'Total Density (MM/ASF)',
                  values: {
                    if: [
                      [
                        {
                          not: {
                            '=': [
                              {
                                '@$': 'piRecordId',
                              },
                              null,
                            ],
                          },
                        },
                        {
                          '[]': [
                            {
                              '{}': {
                                name: {
                                  '@': 'piName',
                                },
                                points: {
                                  '[]': [
                                    {
                                      '{}': {
                                        x: '2023',
                                        y: {
                                          '+': {
                                            '->': [
                                              {
                                                '@': '2023_Pis',
                                              },
                                              {
                                                '@>': [
                                                  {
                                                    '@$': '$value',
                                                  },
                                                  'selectedPiDensity',
                                                ],
                                              },
                                            ],
                                          },
                                        },
                                      },
                                    },
                                    {
                                      '{}': {
                                        x: '2024',
                                        y: {
                                          '+': {
                                            '->': [
                                              {
                                                '@': '2024_Pis',
                                              },
                                              {
                                                '@>': [
                                                  {
                                                    '@$': '$value',
                                                  },
                                                  'selectedPiDensity',
                                                ],
                                              },
                                            ],
                                          },
                                        },
                                      },
                                    },
                                  ],
                                },
                              },
                            },
                            {
                              '{}': {
                                name: 'Average across all PIs',
                                points: {
                                  '[]': [
                                    {
                                      '{}': {
                                        x: '2023',
                                        y: {
                                          '/': [
                                            {
                                              '+': {
                                                '->': [
                                                  {
                                                    '@': '2023_Pis',
                                                  },
                                                  {
                                                    '@>': [
                                                      {
                                                        '@$': '$value',
                                                      },
                                                      'density',
                                                    ],
                                                  },
                                                ],
                                              },
                                            },
                                            {
                                              '+': {
                                                '->': [
                                                  {
                                                    '@': '2023_Pis',
                                                  },
                                                  {
                                                    '@>': [
                                                      {
                                                        '@$': '$value',
                                                      },
                                                      'useForComputeAvgDensity',
                                                    ],
                                                  },
                                                ],
                                              },
                                            },
                                          ],
                                        },
                                      },
                                    },
                                    {
                                      '{}': {
                                        x: '2024',
                                        y: {
                                          '/': [
                                            {
                                              '+': {
                                                '->': [
                                                  {
                                                    '@': '2024_Pis',
                                                  },
                                                  {
                                                    '@>': [
                                                      {
                                                        '@$': '$value',
                                                      },
                                                      'density',
                                                    ],
                                                  },
                                                ],
                                              },
                                            },
                                            {
                                              '+': {
                                                '->': [
                                                  {
                                                    '@': '2024_Pis',
                                                  },
                                                  {
                                                    '@>': [
                                                      {
                                                        '@$': '$value',
                                                      },
                                                      'useForComputeAvgDensity',
                                                    ],
                                                  },
                                                ],
                                              },
                                            },
                                          ],
                                        },
                                      },
                                    },
                                  ],
                                },
                              },
                            },
                          ],
                        },
                      ],
                      [
                        {
                          and: [
                            {
                              not: {
                                '=': [
                                  {
                                    '@$': 'orgRecordId',
                                  },
                                  null,
                                ],
                              },
                            },
                            {
                              not: {
                                '=': [
                                  {
                                    '@$': 'orgEntityId',
                                  },
                                  null,
                                ],
                              },
                            },
                          ],
                        },
                        {
                          '[]': [
                            {
                              '{}': {
                                name: {
                                  '@': 'orgName',
                                },
                                points: {
                                  '[]': [
                                    {
                                      '{}': {
                                        x: '2023',
                                        y: {
                                          '+': {
                                            '->': [
                                              {
                                                '@': '2023_orgs',
                                              },
                                              {
                                                '@>': [
                                                  {
                                                    '@$': '$value',
                                                  },
                                                  'selectedOrgDensity',
                                                ],
                                              },
                                            ],
                                          },
                                        },
                                      },
                                    },
                                    {
                                      '{}': {
                                        x: '2024',
                                        y: {
                                          '+': {
                                            '->': [
                                              {
                                                '@': '2024_orgs',
                                              },
                                              {
                                                '@>': [
                                                  {
                                                    '@$': '$value',
                                                  },
                                                  'selectedOrgDensity',
                                                ],
                                              },
                                            ],
                                          },
                                        },
                                      },
                                    },
                                  ],
                                },
                              },
                            },
                            {
                              '{}': {
                                name: 'Average across all Organizations',
                                points: {
                                  '[]': [
                                    {
                                      '{}': {
                                        x: '2023',
                                        y: {
                                          '/': [
                                            {
                                              '+': {
                                                '->': [
                                                  {
                                                    '@': '2023_orgs',
                                                  },
                                                  {
                                                    '@>': [
                                                      {
                                                        '@$': '$value',
                                                      },
                                                      'density',
                                                    ],
                                                  },
                                                ],
                                              },
                                            },
                                            {
                                              '+': {
                                                '->': [
                                                  {
                                                    '@': '2023_orgs',
                                                  },
                                                  {
                                                    '@>': [
                                                      {
                                                        '@$': '$value',
                                                      },
                                                      'useForComputeAvgDensity',
                                                    ],
                                                  },
                                                ],
                                              },
                                            },
                                          ],
                                        },
                                      },
                                    },
                                    {
                                      '{}': {
                                        x: '2024',
                                        y: {
                                          '/': [
                                            {
                                              '+': {
                                                '->': [
                                                  {
                                                    '@': '2024_orgs',
                                                  },
                                                  {
                                                    '@>': [
                                                      {
                                                        '@$': '$value',
                                                      },
                                                      'density',
                                                    ],
                                                  },
                                                ],
                                              },
                                            },
                                            {
                                              '+': {
                                                '->': [
                                                  {
                                                    '@': '2024_orgs',
                                                  },
                                                  {
                                                    '@>': [
                                                      {
                                                        '@$': '$value',
                                                      },
                                                      'useForComputeAvgDensity',
                                                    ],
                                                  },
                                                ],
                                              },
                                            },
                                          ],
                                        },
                                      },
                                    },
                                  ],
                                },
                              },
                            },
                          ],
                        },
                      ],
                      {
                        '[]': [
                          {
                            '{}': {
                              name: '',
                              points: {
                                '[]': [
                                  {
                                    '{}': {
                                      x: '2023',
                                      y: {
                                        '/': [
                                          {
                                            '+': {
                                              '->': [
                                                {
                                                  '@': '2023_projectsGlExpenses',
                                                },
                                                {
                                                  '@>': [
                                                    {
                                                      '@$': '$value',
                                                    },
                                                    {
                                                      if: [
                                                        [
                                                          {
                                                            '=': [
                                                              {
                                                                '@$': 'financialVolume',
                                                              },
                                                              'MTDC',
                                                            ],
                                                          },
                                                          'mtdcAmount',
                                                        ],
                                                        'tdcAmount',
                                                      ],
                                                    },
                                                  ],
                                                },
                                              ],
                                            },
                                          },
                                          {
                                            '+': {
                                              '->': [
                                                {
                                                  '@': '2023_rooms',
                                                },
                                                {
                                                  '@>': [
                                                    {
                                                      '@$': '$value',
                                                    },
                                                    'asf',
                                                  ],
                                                },
                                              ],
                                            },
                                          },
                                        ],
                                      },
                                    },
                                  },
                                  {
                                    '{}': {
                                      x: '2024',
                                      y: {
                                        '/': [
                                          {
                                            '+': {
                                              '->': [
                                                {
                                                  '@': '2024_projectsGlExpenses',
                                                },
                                                {
                                                  '@>': [
                                                    {
                                                      '@$': '$value',
                                                    },
                                                    {
                                                      if: [
                                                        [
                                                          {
                                                            '=': [
                                                              {
                                                                '@$': 'financialVolume',
                                                              },
                                                              'MTDC',
                                                            ],
                                                          },
                                                          'mtdcAmount',
                                                        ],
                                                        'tdcAmount',
                                                      ],
                                                    },
                                                  ],
                                                },
                                              ],
                                            },
                                          },
                                          {
                                            '+': {
                                              '->': [
                                                {
                                                  '@': '2024_rooms',
                                                },
                                                {
                                                  '@>': [
                                                    {
                                                      '@$': '$value',
                                                    },
                                                    'asf',
                                                  ],
                                                },
                                              ],
                                            },
                                          },
                                        ],
                                      },
                                    },
                                  },
                                ],
                              },
                            },
                          },
                        ],
                      },
                    ],
                  },
                },
              },
              {
                '{}': {
                  name: 'Utilization (%)',
                  values: {
                    if: [
                      [
                        {
                          not: {
                            '=': [
                              {
                                '@$': 'piRecordId',
                              },
                              null,
                            ],
                          },
                        },
                        {
                          '[]': [
                            {
                              '{}': {
                                name: {
                                  '@': 'piName',
                                },
                                points: {
                                  '[]': [
                                    {
                                      '{}': {
                                        x: '2023',
                                        y: {
                                          '*': [
                                            100,
                                            {
                                              '+': {
                                                '->': [
                                                  {
                                                    '@': '2023_Pis',
                                                  },
                                                  {
                                                    '@>': [
                                                      {
                                                        '@$': '$value',
                                                      },
                                                      'selectedPiUtilization',
                                                    ],
                                                  },
                                                ],
                                              },
                                            },
                                          ],
                                        },
                                      },
                                    },
                                    {
                                      '{}': {
                                        x: '2024',
                                        y: {
                                          '*': [
                                            100,
                                            {
                                              '+': {
                                                '->': [
                                                  {
                                                    '@': '2024_Pis',
                                                  },
                                                  {
                                                    '@>': [
                                                      {
                                                        '@$': '$value',
                                                      },
                                                      'selectedPiUtilization',
                                                    ],
                                                  },
                                                ],
                                              },
                                            },
                                          ],
                                        },
                                      },
                                    },
                                  ],
                                },
                              },
                            },
                            {
                              '{}': {
                                name: 'Average across all PIs',
                                points: {
                                  '[]': [
                                    {
                                      '{}': {
                                        x: '2023',
                                        y: {
                                          '*': [
                                            100,
                                            {
                                              '/': [
                                                {
                                                  '+': {
                                                    '->': [
                                                      {
                                                        '@': '2023_Pis',
                                                      },
                                                      {
                                                        '@>': [
                                                          {
                                                            '@$': '$value',
                                                          },
                                                          'utilization',
                                                        ],
                                                      },
                                                    ],
                                                  },
                                                },
                                                {
                                                  '+': {
                                                    '->': [
                                                      {
                                                        '@': '2023_Pis',
                                                      },
                                                      {
                                                        '@>': [
                                                          {
                                                            '@$': '$value',
                                                          },
                                                          'useForComputeAvgUtilization',
                                                        ],
                                                      },
                                                    ],
                                                  },
                                                },
                                              ],
                                            },
                                          ],
                                        },
                                      },
                                    },
                                    {
                                      '{}': {
                                        x: '2024',
                                        y: {
                                          '*': [
                                            100,
                                            {
                                              '/': [
                                                {
                                                  '+': {
                                                    '->': [
                                                      {
                                                        '@': '2024_Pis',
                                                      },
                                                      {
                                                        '@>': [
                                                          {
                                                            '@$': '$value',
                                                          },
                                                          'utilization',
                                                        ],
                                                      },
                                                    ],
                                                  },
                                                },
                                                {
                                                  '+': {
                                                    '->': [
                                                      {
                                                        '@': '2024_Pis',
                                                      },
                                                      {
                                                        '@>': [
                                                          {
                                                            '@$': '$value',
                                                          },
                                                          'useForComputeAvgUtilization',
                                                        ],
                                                      },
                                                    ],
                                                  },
                                                },
                                              ],
                                            },
                                          ],
                                        },
                                      },
                                    },
                                  ],
                                },
                              },
                            },
                          ],
                        },
                      ],
                      [
                        {
                          and: [
                            {
                              not: {
                                '=': [
                                  {
                                    '@$': 'orgRecordId',
                                  },
                                  null,
                                ],
                              },
                            },
                            {
                              not: {
                                '=': [
                                  {
                                    '@$': 'orgEntityId',
                                  },
                                  null,
                                ],
                              },
                            },
                          ],
                        },
                        {
                          '[]': [
                            {
                              '{}': {
                                name: {
                                  '@': 'orgName',
                                },
                                points: {
                                  '[]': [
                                    {
                                      '{}': {
                                        x: '2023',
                                        y: {
                                          '*': [
                                            100,
                                            {
                                              '+': {
                                                '->': [
                                                  {
                                                    '@': '2023_orgs',
                                                  },
                                                  {
                                                    '@>': [
                                                      {
                                                        '@$': '$value',
                                                      },
                                                      'selectedOrgUtilization',
                                                    ],
                                                  },
                                                ],
                                              },
                                            },
                                          ],
                                        },
                                      },
                                    },
                                    {
                                      '{}': {
                                        x: '2024',
                                        y: {
                                          '*': [
                                            100,
                                            {
                                              '+': {
                                                '->': [
                                                  {
                                                    '@': '2024_orgs',
                                                  },
                                                  {
                                                    '@>': [
                                                      {
                                                        '@$': '$value',
                                                      },
                                                      'selectedOrgUtilization',
                                                    ],
                                                  },
                                                ],
                                              },
                                            },
                                          ],
                                        },
                                      },
                                    },
                                  ],
                                },
                              },
                            },
                            {
                              '{}': {
                                name: 'Average across all Organizations',
                                points: {
                                  '[]': [
                                    {
                                      '{}': {
                                        x: '2023',
                                        y: {
                                          '*': [
                                            100,
                                            {
                                              '/': [
                                                {
                                                  '+': {
                                                    '->': [
                                                      {
                                                        '@': '2023_orgs',
                                                      },
                                                      {
                                                        '@>': [
                                                          {
                                                            '@$': '$value',
                                                          },
                                                          'utilization',
                                                        ],
                                                      },
                                                    ],
                                                  },
                                                },
                                                {
                                                  '+': {
                                                    '->': [
                                                      {
                                                        '@': '2023_orgs',
                                                      },
                                                      {
                                                        '@>': [
                                                          {
                                                            '@$': '$value',
                                                          },
                                                          'useForComputeAvgUtilization',
                                                        ],
                                                      },
                                                    ],
                                                  },
                                                },
                                              ],
                                            },
                                          ],
                                        },
                                      },
                                    },
                                    {
                                      '{}': {
                                        x: '2024',
                                        y: {
                                          '*': [
                                            100,
                                            {
                                              '/': [
                                                {
                                                  '+': {
                                                    '->': [
                                                      {
                                                        '@': '2024_orgs',
                                                      },
                                                      {
                                                        '@>': [
                                                          {
                                                            '@$': '$value',
                                                          },
                                                          'utilization',
                                                        ],
                                                      },
                                                    ],
                                                  },
                                                },
                                                {
                                                  '+': {
                                                    '->': [
                                                      {
                                                        '@': '2024_orgs',
                                                      },
                                                      {
                                                        '@>': [
                                                          {
                                                            '@$': '$value',
                                                          },
                                                          'useForComputeAvgUtilization',
                                                        ],
                                                      },
                                                    ],
                                                  },
                                                },
                                              ],
                                            },
                                          ],
                                        },
                                      },
                                    },
                                  ],
                                },
                              },
                            },
                          ],
                        },
                      ],
                      {
                        '[]': [
                          {
                            '{}': {
                              name: '',
                              points: {
                                '[]': [
                                  {
                                    '{}': {
                                      x: '2023',
                                      y: {
                                        '*': [
                                          100,
                                          {
                                            '/': [
                                              {
                                                '+': {
                                                  '->': [
                                                    {
                                                      '@': '2023_rooms',
                                                    },
                                                    {
                                                      '@>': [
                                                        {
                                                          '@$': '$value',
                                                        },
                                                        'asf',
                                                      ],
                                                    },
                                                  ],
                                                },
                                              },
                                              {
                                                '+': {
                                                  '->': [
                                                    {
                                                      '@': '2023_rooms',
                                                    },
                                                    {
                                                      '@>': [
                                                        {
                                                          '@$': '$value',
                                                        },
                                                        'sqft',
                                                      ],
                                                    },
                                                  ],
                                                },
                                              },
                                            ],
                                          },
                                        ],
                                      },
                                    },
                                  },
                                  {
                                    '{}': {
                                      x: '2024',
                                      y: {
                                        '*': [
                                          100,
                                          {
                                            '/': [
                                              {
                                                '+': {
                                                  '->': [
                                                    {
                                                      '@': '2024_rooms',
                                                    },
                                                    {
                                                      '@>': [
                                                        {
                                                          '@$': '$value',
                                                        },
                                                        'asf',
                                                      ],
                                                    },
                                                  ],
                                                },
                                              },
                                              {
                                                '+': {
                                                  '->': [
                                                    {
                                                      '@': '2024_rooms',
                                                    },
                                                    {
                                                      '@>': [
                                                        {
                                                          '@$': '$value',
                                                        },
                                                        'sqft',
                                                      ],
                                                    },
                                                  ],
                                                },
                                              },
                                            ],
                                          },
                                        ],
                                      },
                                    },
                                  },
                                ],
                              },
                            },
                          },
                        ],
                      },
                    ],
                  },
                },
              },
            ],
          },
          type: 'bar',
        },
      },
    },
  },
  variables: {
    researchType: ['BASIC RESEARCH'],
    shouldAnalyze: true,
  },
  subqueries: {
    piName: {
      filter: {
        and: [
          {
            '@$': 'piRecordId',
          },
          {
            '=': [
              {
                '@.': '!id',
              },
              {
                '@$': 'piRecordId',
              },
            ],
          },
        ],
      },
      target: 'ent:!personnel:!employee',
      selection: {
        '@.': '!name',
      },
    },
    orgName: {
      filter: {
        and: [
          {
            '@$': 'orgRecordId',
          },
          {
            '@$': 'orgEntityId',
          },
          {
            '=': [
              {
                '@.': '!id',
              },
              {
                '@$': 'orgRecordId',
              },
            ],
          },
          {
            '=': [
              {
                '@_': 'id',
              },
              {
                '@$': 'orgEntityId',
              },
            ],
          },
        ],
      },
      target: 'dim::!org',
      selection: {
        '@.': '!name',
      },
    },
    '2023_Pis': {
      filter: {
        '@$': 'piRecordId',
      },
      period: {
        $range: {
          end: {
            $date: '12/31/2023',
          },
          start: {
            $date: '01/01/2023',
          },
        },
      },
      target: 'ent:!personnel:!employee',
      selection: {
        '{}': {
          name: {
            '@.': '!name',
          },
          density: {
            if: [
              [
                {
                  '=': [
                    {
                      '@>': 'totalAsf',
                    },
                    0,
                  ],
                },
                0,
              ],
              {
                '/': [
                  {
                    '@>': 'projectsExpenses',
                  },
                  {
                    '@>': 'totalAsf',
                  },
                ],
              },
            ],
          },
          totalAsf: {
            '??': [
              {
                '+': {
                  '->': [
                    {
                      '@': 'rooms',
                    },
                    {
                      '@>': [
                        {
                          '@$': '$value',
                        },
                        'asf',
                      ],
                    },
                  ],
                },
              },
              0,
            ],
          },
          tdcAmount: {
            '??': [
              {
                '+': {
                  '->': [
                    {
                      '@': 'projectsExpenses',
                    },
                    {
                      '@>': [
                        {
                          '@$': '$value',
                        },
                        'tdcAmount',
                      ],
                    },
                  ],
                },
              },
              0,
            ],
          },
          totalSqft: {
            '??': [
              {
                '+': {
                  '->': [
                    {
                      '@': 'rooms',
                    },
                    {
                      '@>': [
                        {
                          '@$': '$value',
                        },
                        'sqft',
                      ],
                    },
                  ],
                },
              },
              0,
            ],
          },
          isSelected: {
            if: [
              [
                {
                  '=': [
                    {
                      '@.': '!id',
                    },
                    {
                      '@$': 'piRecordId',
                    },
                  ],
                },
                1,
              ],
              0,
            ],
          },
          mtdcAmount: {
            '??': [
              {
                '+': {
                  '->': [
                    {
                      '@': 'projectsExpenses',
                    },
                    {
                      '@>': [
                        {
                          '@$': '$value',
                        },
                        'mtdcAmount',
                      ],
                    },
                  ],
                },
              },
              0,
            ],
          },
          utilization: {
            if: [
              [
                {
                  '=': [
                    {
                      '@>': 'totalSqft',
                    },
                    0,
                  ],
                },
                0,
              ],
              {
                '/': [
                  {
                    '@>': 'totalAsf',
                  },
                  {
                    '@>': 'totalSqft',
                  },
                ],
              },
            ],
          },
          projectsExpenses: {
            if: [
              [
                {
                  '=': [
                    {
                      '@$': 'financialVolume',
                    },
                    'MTDC',
                  ],
                },
                {
                  '@>': 'mtdcAmount',
                },
              ],
              {
                '@>': 'tdcAmount',
              },
            ],
          },
          selectedPiDensity: {
            '*': [
              {
                '@>': 'density',
              },
              {
                '@>': 'isSelected',
              },
            ],
          },
          selectedPiUtilization: {
            '*': [
              {
                '@>': 'utilization',
              },
              {
                '@>': 'isSelected',
              },
            ],
          },
          useForComputeAvgDensity: {
            if: [
              [
                {
                  '!=': [
                    {
                      '@>': 'totalAsf',
                    },
                    0,
                  ],
                },
                1,
              ],
              0,
            ],
          },
          selectedPiProjectsExpenses: {
            '*': [
              {
                '@>': 'projectsExpenses',
              },
              {
                '@>': 'isSelected',
              },
            ],
          },
          useForComputeAvgUtilization: {
            if: [
              [
                {
                  '!=': [
                    {
                      '@>': 'totalSqft',
                    },
                    0,
                  ],
                },
                1,
              ],
              0,
            ],
          },
        },
      },
      subqueries: {
        rooms: {
          ref: {
            attr: 'attr:ent#!person_space#!entry:!space',
          },
          using: 'piSpaceAssignments',
          filter: {
            and: [
              {
                or: [
                  {
                    '=': [
                      {
                        '@$': 'spaceType',
                      },
                      null,
                    ],
                  },
                  {
                    in: [
                      {
                        '@.': [
                          '!space_use',
                          {
                            ref: {
                              entity: '!group',
                            },
                          },
                        ],
                      },
                      {
                        '@>': [
                          {
                            '@$': 'spaceType',
                          },
                          'ent:!space_use:!group',
                        ],
                      },
                    ],
                  },
                ],
              },
              {
                if: [
                  [
                    {
                      '@$': 'shouldAnalyze',
                    },
                    {
                      '=': [
                        {
                          '@$': 'shouldAnalyze',
                        },
                        {
                          in: [
                            true,
                            {
                              '@': 'shouldAnalyze',
                            },
                          ],
                        },
                      ],
                    },
                  ],
                  true,
                ],
              },
            ],
          },
          target: 'ent:!space:!room',
          selection: {
            '{}': {
              asf: {
                '*': [
                  {
                    '@.': '!sqft',
                  },
                  {
                    '/': [
                      {
                        '+': {
                          '->': [
                            {
                              '@': 'weights',
                            },
                            {
                              '*': [
                                {
                                  '@>': [
                                    {
                                      '@$': '$value',
                                    },
                                    'value',
                                  ],
                                },
                                {
                                  '@>': [
                                    {
                                      '@$': '$value',
                                    },
                                    'allowable',
                                  ],
                                },
                              ],
                            },
                          ],
                        },
                      },
                      {
                        '+': {
                          '->': [
                            {
                              '@': 'weights',
                            },
                            {
                              '@>': [
                                {
                                  '@$': '$value',
                                },
                                'value',
                              ],
                            },
                          ],
                        },
                      },
                    ],
                  },
                ],
              },
              sqft: {
                '@.': '!sqft',
              },
            },
          },
          subqueries: {
            weights: {
              ref: {
                attr: 'attr:ent#!space_funcl#!entry:!space',
                inherit: '-',
              },
              filter: {
                '!=': [
                  {
                    '@.': '!weight',
                  },
                  0,
                ],
              },
              target: 'ent:!space_funcl:!entry',
              selection: {
                '{}': {
                  value: {
                    '@.': '!weight',
                  },
                  allowable: {
                    if: [
                      [
                        {
                          '!=': [
                            {
                              '@': 'funcIdCat',
                            },
                            null,
                          ],
                        },
                        1,
                      ],
                      0,
                    ],
                  },
                },
              },
              subqueries: {
                funcIdCat: {
                  ref: {
                    attr: 'attr:ent#!space_funcl#!entry:!func_space',
                  },
                  target: 'ent:!func_space:!func',
                  selection: {
                    '@.': [
                      '!func_idc',
                      {
                        ref: {
                          entity: '!cat',
                        },
                      },
                    ],
                  },
                },
              },
            },
            roomOrgs: {
              ref: {
                attr: 'attr:ent#!org_space#!entry:!space',
              },
              target: 'ent:!org_space:!entry',
            },
            shouldAnalyze: {
              ref: {
                attr: 'attr:ent#!org_space#!entry:!org',
              },
              using: 'roomOrgs',
              target: 'ent:!org:!dept',
              selection: {
                '@.': '!should_analyze',
              },
            },
          },
        },
        projectsExpenses: {
          ref: {
            attr: 'attr:ent#!proj_pis#!entry:!proj',
          },
          using: 'piProjectAssignments',
          filter: {
            and: [
              {
                not: {
                  '=': [
                    {
                      '@': 'projectGlExpenseAmounts',
                    },
                    null,
                  ],
                },
              },
              {
                or: [
                  {
                    '=': [
                      {
                        '@$': 'researchType',
                      },
                      null,
                    ],
                  },
                  {
                    '=': [
                      {
                        '#': {
                          '@$': 'researchType',
                        },
                      },
                      0,
                    ],
                  },
                  {
                    in: [
                      {
                        '@.': '!research_type_wfuhs',
                      },
                      {
                        '@$': 'researchType',
                      },
                    ],
                  },
                ],
              },
              {
                if: [
                  [
                    {
                      '@$': 'shouldAnalyze',
                    },
                    {
                      '=': [
                        {
                          '@$': 'shouldAnalyze',
                        },
                        {
                          '@': 'shouldAnalyze',
                        },
                      ],
                    },
                  ],
                  true,
                ],
              },
            ],
          },
          target: 'ent:!projects:!proj',
          selection: {
            '{}': {
              tdcAmount: {
                '+': {
                  '->': [
                    {
                      '@': 'projectGlExpenseAmounts',
                    },
                    {
                      '@>': [
                        {
                          '@$': '$value',
                        },
                        'tdcAmount',
                      ],
                    },
                  ],
                },
              },
              mtdcAmount: {
                '+': {
                  '->': [
                    {
                      '@': 'projectGlExpenseAmounts',
                    },
                    {
                      '@>': [
                        {
                          '@$': '$value',
                        },
                        'mtdcAmount',
                      ],
                    },
                  ],
                },
              },
            },
          },
          subqueries: {
            shouldAnalyze: {
              ref: {
                attr: 'attr:ent#!projects#!proj:!org',
              },
              target: 'ent:!org:!dept',
              selection: {
                '@.': '!should_analyze',
              },
            },
            projectGlExpenseAmounts: {
              ref: {
                attr: 'attr:ent#!gl_exp#!entry:!proj',
              },
              target: 'ent:!gl_exp:!entry',
              selection: {
                '{}': {
                  tdcAmount: {
                    '@.': '!amount',
                  },
                  mtdcAmount: {
                    if: [
                      [
                        {
                          '@': 'isInMtdc',
                        },
                        {
                          '@.': '!amount',
                        },
                      ],
                      0,
                    ],
                  },
                },
              },
              subqueries: {
                isInMtdc: {
                  ref: {
                    attr: 'attr:ent#!gl_exp#!entry:!acct',
                  },
                  target: 'ent:!gl_accts:!acct',
                  selection: {
                    '@.': '!is_in_mtdc',
                  },
                },
              },
            },
          },
        },
        piSpaceAssignments: {
          ref: {
            attr: 'attr:ent#!person_space#!entry:!personnel',
          },
          target: 'ent:!person_space:!entry',
        },
        piProjectAssignments: {
          ref: {
            attr: 'attr:ent#!proj_pis#!entry:!pi',
          },
          target: 'ent:!proj_pis:!entry',
        },
      },
    },
    '2024_Pis': {
      filter: {
        '@$': 'piRecordId',
      },
      period: {
        $range: {
          end: {
            $date: '12/31/2024',
          },
          start: {
            $date: '01/01/2024',
          },
        },
      },
      target: 'ent:!personnel:!employee',
      selection: {
        '{}': {
          name: {
            '@.': '!name',
          },
          density: {
            if: [
              [
                {
                  '=': [
                    {
                      '@>': 'totalAsf',
                    },
                    0,
                  ],
                },
                0,
              ],
              {
                '/': [
                  {
                    '@>': 'projectsExpenses',
                  },
                  {
                    '@>': 'totalAsf',
                  },
                ],
              },
            ],
          },
          totalAsf: {
            '??': [
              {
                '+': {
                  '->': [
                    {
                      '@': 'rooms',
                    },
                    {
                      '@>': [
                        {
                          '@$': '$value',
                        },
                        'asf',
                      ],
                    },
                  ],
                },
              },
              0,
            ],
          },
          tdcAmount: {
            '??': [
              {
                '+': {
                  '->': [
                    {
                      '@': 'projectsExpenses',
                    },
                    {
                      '@>': [
                        {
                          '@$': '$value',
                        },
                        'tdcAmount',
                      ],
                    },
                  ],
                },
              },
              0,
            ],
          },
          totalSqft: {
            '??': [
              {
                '+': {
                  '->': [
                    {
                      '@': 'rooms',
                    },
                    {
                      '@>': [
                        {
                          '@$': '$value',
                        },
                        'sqft',
                      ],
                    },
                  ],
                },
              },
              0,
            ],
          },
          isSelected: {
            if: [
              [
                {
                  '=': [
                    {
                      '@.': '!id',
                    },
                    {
                      '@$': 'piRecordId',
                    },
                  ],
                },
                1,
              ],
              0,
            ],
          },
          mtdcAmount: {
            '??': [
              {
                '+': {
                  '->': [
                    {
                      '@': 'projectsExpenses',
                    },
                    {
                      '@>': [
                        {
                          '@$': '$value',
                        },
                        'mtdcAmount',
                      ],
                    },
                  ],
                },
              },
              0,
            ],
          },
          utilization: {
            if: [
              [
                {
                  '=': [
                    {
                      '@>': 'totalSqft',
                    },
                    0,
                  ],
                },
                0,
              ],
              {
                '/': [
                  {
                    '@>': 'totalAsf',
                  },
                  {
                    '@>': 'totalSqft',
                  },
                ],
              },
            ],
          },
          projectsExpenses: {
            if: [
              [
                {
                  '=': [
                    {
                      '@$': 'financialVolume',
                    },
                    'MTDC',
                  ],
                },
                {
                  '@>': 'mtdcAmount',
                },
              ],
              {
                '@>': 'tdcAmount',
              },
            ],
          },
          selectedPiDensity: {
            '*': [
              {
                '@>': 'density',
              },
              {
                '@>': 'isSelected',
              },
            ],
          },
          selectedPiUtilization: {
            '*': [
              {
                '@>': 'utilization',
              },
              {
                '@>': 'isSelected',
              },
            ],
          },
          useForComputeAvgDensity: {
            if: [
              [
                {
                  '!=': [
                    {
                      '@>': 'totalAsf',
                    },
                    0,
                  ],
                },
                1,
              ],
              0,
            ],
          },
          selectedPiProjectsExpenses: {
            '*': [
              {
                '@>': 'projectsExpenses',
              },
              {
                '@>': 'isSelected',
              },
            ],
          },
          useForComputeAvgUtilization: {
            if: [
              [
                {
                  '!=': [
                    {
                      '@>': 'totalSqft',
                    },
                    0,
                  ],
                },
                1,
              ],
              0,
            ],
          },
        },
      },
      subqueries: {
        rooms: {
          ref: {
            attr: 'attr:ent#!person_space#!entry:!space',
          },
          using: 'piSpaceAssignments',
          filter: {
            and: [
              {
                or: [
                  {
                    '=': [
                      {
                        '@$': 'spaceType',
                      },
                      null,
                    ],
                  },
                  {
                    in: [
                      {
                        '@.': [
                          '!space_use',
                          {
                            ref: {
                              entity: '!group',
                            },
                          },
                        ],
                      },
                      {
                        '@>': [
                          {
                            '@$': 'spaceType',
                          },
                          'ent:!space_use:!group',
                        ],
                      },
                    ],
                  },
                ],
              },
              {
                if: [
                  [
                    {
                      '@$': 'shouldAnalyze',
                    },
                    {
                      '=': [
                        {
                          '@$': 'shouldAnalyze',
                        },
                        {
                          in: [
                            true,
                            {
                              '@': 'shouldAnalyze',
                            },
                          ],
                        },
                      ],
                    },
                  ],
                  true,
                ],
              },
            ],
          },
          target: 'ent:!space:!room',
          selection: {
            '{}': {
              asf: {
                '*': [
                  {
                    '@.': '!sqft',
                  },
                  {
                    '/': [
                      {
                        '+': {
                          '->': [
                            {
                              '@': 'weights',
                            },
                            {
                              '*': [
                                {
                                  '@>': [
                                    {
                                      '@$': '$value',
                                    },
                                    'value',
                                  ],
                                },
                                {
                                  '@>': [
                                    {
                                      '@$': '$value',
                                    },
                                    'allowable',
                                  ],
                                },
                              ],
                            },
                          ],
                        },
                      },
                      {
                        '+': {
                          '->': [
                            {
                              '@': 'weights',
                            },
                            {
                              '@>': [
                                {
                                  '@$': '$value',
                                },
                                'value',
                              ],
                            },
                          ],
                        },
                      },
                    ],
                  },
                ],
              },
              sqft: {
                '@.': '!sqft',
              },
            },
          },
          subqueries: {
            weights: {
              ref: {
                attr: 'attr:ent#!space_funcl#!entry:!space',
                inherit: '-',
              },
              filter: {
                '!=': [
                  {
                    '@.': '!weight',
                  },
                  0,
                ],
              },
              target: 'ent:!space_funcl:!entry',
              selection: {
                '{}': {
                  value: {
                    '@.': '!weight',
                  },
                  allowable: {
                    if: [
                      [
                        {
                          '!=': [
                            {
                              '@': 'funcIdCat',
                            },
                            null,
                          ],
                        },
                        1,
                      ],
                      0,
                    ],
                  },
                },
              },
              subqueries: {
                funcIdCat: {
                  ref: {
                    attr: 'attr:ent#!space_funcl#!entry:!func_space',
                  },
                  target: 'ent:!func_space:!func',
                  selection: {
                    '@.': [
                      '!func_idc',
                      {
                        ref: {
                          entity: '!cat',
                        },
                      },
                    ],
                  },
                },
              },
            },
            roomOrgs: {
              ref: {
                attr: 'attr:ent#!org_space#!entry:!space',
              },
              target: 'ent:!org_space:!entry',
            },
            shouldAnalyze: {
              ref: {
                attr: 'attr:ent#!org_space#!entry:!org',
              },
              using: 'roomOrgs',
              target: 'ent:!org:!dept',
              selection: {
                '@.': '!should_analyze',
              },
            },
          },
        },
        projectsExpenses: {
          ref: {
            attr: 'attr:ent#!proj_pis#!entry:!proj',
          },
          using: 'piProjectAssignments',
          filter: {
            and: [
              {
                not: {
                  '=': [
                    {
                      '@': 'projectGlExpenseAmounts',
                    },
                    null,
                  ],
                },
              },
              {
                or: [
                  {
                    '=': [
                      {
                        '@$': 'researchType',
                      },
                      null,
                    ],
                  },
                  {
                    '=': [
                      {
                        '#': {
                          '@$': 'researchType',
                        },
                      },
                      0,
                    ],
                  },
                  {
                    in: [
                      {
                        '@.': '!research_type_wfuhs',
                      },
                      {
                        '@$': 'researchType',
                      },
                    ],
                  },
                ],
              },
              {
                if: [
                  [
                    {
                      '@$': 'shouldAnalyze',
                    },
                    {
                      '=': [
                        {
                          '@$': 'shouldAnalyze',
                        },
                        {
                          '@': 'shouldAnalyze',
                        },
                      ],
                    },
                  ],
                  true,
                ],
              },
            ],
          },
          target: 'ent:!projects:!proj',
          selection: {
            '{}': {
              tdcAmount: {
                '+': {
                  '->': [
                    {
                      '@': 'projectGlExpenseAmounts',
                    },
                    {
                      '@>': [
                        {
                          '@$': '$value',
                        },
                        'tdcAmount',
                      ],
                    },
                  ],
                },
              },
              mtdcAmount: {
                '+': {
                  '->': [
                    {
                      '@': 'projectGlExpenseAmounts',
                    },
                    {
                      '@>': [
                        {
                          '@$': '$value',
                        },
                        'mtdcAmount',
                      ],
                    },
                  ],
                },
              },
            },
          },
          subqueries: {
            shouldAnalyze: {
              ref: {
                attr: 'attr:ent#!projects#!proj:!org',
              },
              target: 'ent:!org:!dept',
              selection: {
                '@.': '!should_analyze',
              },
            },
            projectGlExpenseAmounts: {
              ref: {
                attr: 'attr:ent#!gl_exp#!entry:!proj',
              },
              target: 'ent:!gl_exp:!entry',
              selection: {
                '{}': {
                  tdcAmount: {
                    '@.': '!amount',
                  },
                  mtdcAmount: {
                    if: [
                      [
                        {
                          '@': 'isInMtdc',
                        },
                        {
                          '@.': '!amount',
                        },
                      ],
                      0,
                    ],
                  },
                },
              },
              subqueries: {
                isInMtdc: {
                  ref: {
                    attr: 'attr:ent#!gl_exp#!entry:!acct',
                  },
                  target: 'ent:!gl_accts:!acct',
                  selection: {
                    '@.': '!is_in_mtdc',
                  },
                },
              },
            },
          },
        },
        piSpaceAssignments: {
          ref: {
            attr: 'attr:ent#!person_space#!entry:!personnel',
          },
          target: 'ent:!person_space:!entry',
        },
        piProjectAssignments: {
          ref: {
            attr: 'attr:ent#!proj_pis#!entry:!pi',
          },
          target: 'ent:!proj_pis:!entry',
        },
      },
    },
    '2023_orgs': {
      filter: {
        and: [
          {
            '@$': 'orgEntityId',
          },
          {
            '@$': 'orgRecordId',
          },
          {
            if: [
              [
                {
                  '@$': 'shouldAnalyze',
                },
                {
                  '=': [
                    {
                      '@$': 'shouldAnalyze',
                    },
                    {
                      '@.': '!should_analyze',
                    },
                  ],
                },
              ],
              true,
            ],
          },
          {
            '=': [
              {
                '@_': 'id',
              },
              {
                '@$': 'orgEntityId',
              },
            ],
          },
        ],
      },
      period: {
        $range: {
          end: {
            $date: '12/31/2023',
          },
          start: {
            $date: '01/01/2023',
          },
        },
      },
      target: 'dim::!org',
      selection: {
        '{}': {
          id: {
            '@.': '!id',
          },
          density: {
            if: [
              [
                {
                  '=': [
                    {
                      '@>': 'totalAsf',
                    },
                    0,
                  ],
                },
                0,
              ],
              {
                '/': [
                  {
                    '@>': 'projectsExpenses',
                  },
                  {
                    '@>': 'totalAsf',
                  },
                ],
              },
            ],
          },
          totalAsf: {
            '??': [
              {
                '+': {
                  '->': [
                    {
                      '@': 'rooms',
                    },
                    {
                      '@>': [
                        {
                          '@$': '$value',
                        },
                        'asf',
                      ],
                    },
                  ],
                },
              },
              0,
            ],
          },
          tdcAmount: {
            '??': [
              {
                '+': {
                  '->': [
                    {
                      '@': 'projectsExpenses',
                    },
                    {
                      '@>': [
                        {
                          '@$': '$value',
                        },
                        'tdcAmount',
                      ],
                    },
                  ],
                },
              },
              0,
            ],
          },
          totalSqft: {
            '??': [
              {
                '+': {
                  '->': [
                    {
                      '@': 'rooms',
                    },
                    {
                      '@>': [
                        {
                          '@$': '$value',
                        },
                        'sqft',
                      ],
                    },
                  ],
                },
              },
              0,
            ],
          },
          isSelected: {
            if: [
              [
                {
                  '=': [
                    {
                      '@.': '!id',
                    },
                    {
                      '@$': 'orgRecordId',
                    },
                  ],
                },
                1,
              ],
              0,
            ],
          },
          mtdcAmount: {
            '??': [
              {
                '+': {
                  '->': [
                    {
                      '@': 'projectsExpenses',
                    },
                    {
                      '@>': [
                        {
                          '@$': '$value',
                        },
                        'mtdcAmount',
                      ],
                    },
                  ],
                },
              },
              0,
            ],
          },
          utilization: {
            if: [
              [
                {
                  '=': [
                    {
                      '@>': 'totalSqft',
                    },
                    0,
                  ],
                },
                0,
              ],
              {
                '/': [
                  {
                    '@>': 'totalAsf',
                  },
                  {
                    '@>': 'totalSqft',
                  },
                ],
              },
            ],
          },
          projectsExpenses: {
            if: [
              [
                {
                  '=': [
                    {
                      '@$': 'financialVolume',
                    },
                    'MTDC',
                  ],
                },
                {
                  '@>': 'mtdcAmount',
                },
              ],
              {
                '@>': 'tdcAmount',
              },
            ],
          },
          selectedOrgDensity: {
            '*': [
              {
                '@>': 'density',
              },
              {
                '@>': 'isSelected',
              },
            ],
          },
          selectedOrgUtilization: {
            '*': [
              {
                '@>': 'utilization',
              },
              {
                '@>': 'isSelected',
              },
            ],
          },
          useForComputeAvgDensity: {
            if: [
              [
                {
                  '!=': [
                    {
                      '@>': 'totalAsf',
                    },
                    0,
                  ],
                },
                1,
              ],
              0,
            ],
          },
          selectedOrgProjectsExpenses: {
            '*': [
              {
                '@>': 'projectsExpenses',
              },
              {
                '@>': 'isSelected',
              },
            ],
          },
          useForComputeAvgUtilization: {
            if: [
              [
                {
                  '!=': [
                    {
                      '@>': 'totalSqft',
                    },
                    0,
                  ],
                },
                1,
              ],
              0,
            ],
          },
        },
      },
      subqueries: {
        rooms: {
          ref: {
            attr: 'attr:ent#!org_space#!entry:!space',
          },
          using: 'orgSpaceAssignments',
          filter: {
            or: [
              {
                '=': [
                  {
                    '@$': 'spaceType',
                  },
                  null,
                ],
              },
              {
                in: [
                  {
                    '@.': [
                      '!space_use',
                      {
                        ref: {
                          entity: '!group',
                        },
                      },
                    ],
                  },
                  {
                    '@>': [
                      {
                        '@$': 'spaceType',
                      },
                      'ent:!space_use:!group',
                    ],
                  },
                ],
              },
            ],
          },
          target: 'ent:!space:!room',
          selection: {
            '{}': {
              asf: {
                '*': [
                  {
                    '@.': '!sqft',
                  },
                  {
                    '/': [
                      {
                        '+': {
                          '->': [
                            {
                              '@': 'weights',
                            },
                            {
                              '*': [
                                {
                                  '@>': [
                                    {
                                      '@$': '$value',
                                    },
                                    'value',
                                  ],
                                },
                                {
                                  '@>': [
                                    {
                                      '@$': '$value',
                                    },
                                    'allowable',
                                  ],
                                },
                              ],
                            },
                          ],
                        },
                      },
                      {
                        '+': {
                          '->': [
                            {
                              '@': 'weights',
                            },
                            {
                              '@>': [
                                {
                                  '@$': '$value',
                                },
                                'value',
                              ],
                            },
                          ],
                        },
                      },
                    ],
                  },
                ],
              },
              sqft: {
                '@.': '!sqft',
              },
            },
          },
          subqueries: {
            weights: {
              ref: {
                attr: 'attr:ent#!space_funcl#!entry:!space',
                inherit: '-',
              },
              filter: {
                '!=': [
                  {
                    '@.': '!weight',
                  },
                  0,
                ],
              },
              target: 'ent:!space_funcl:!entry',
              selection: {
                '{}': {
                  value: {
                    '@.': '!weight',
                  },
                  allowable: {
                    if: [
                      [
                        {
                          '!=': [
                            {
                              '@': 'funcIdCat',
                            },
                            null,
                          ],
                        },
                        1,
                      ],
                      0,
                    ],
                  },
                },
              },
              subqueries: {
                funcIdCat: {
                  ref: {
                    attr: 'attr:ent#!space_funcl#!entry:!func_space',
                  },
                  target: 'ent:!func_space:!func',
                  selection: {
                    '@.': [
                      '!func_idc',
                      {
                        ref: {
                          entity: '!cat',
                        },
                      },
                    ],
                  },
                },
              },
            },
          },
        },
        projectsExpenses: {
          ref: {
            attr: 'attr:ent#!projects#!proj:!org',
            inherit: '-',
          },
          filter: {
            and: [
              {
                not: {
                  '=': [
                    {
                      '@': 'projectGlExpenseAmounts',
                    },
                    null,
                  ],
                },
              },
              {
                or: [
                  {
                    '=': [
                      {
                        '@$': 'researchType',
                      },
                      null,
                    ],
                  },
                  {
                    '=': [
                      {
                        '#': {
                          '@$': 'researchType',
                        },
                      },
                      0,
                    ],
                  },
                  {
                    in: [
                      {
                        '@.': '!research_type_wfuhs',
                      },
                      {
                        '@$': 'researchType',
                      },
                    ],
                  },
                ],
              },
            ],
          },
          target: 'ent:!projects:!proj',
          selection: {
            '{}': {
              tdcAmount: {
                '+': {
                  '->': [
                    {
                      '@': 'projectGlExpenseAmounts',
                    },
                    {
                      '@>': [
                        {
                          '@$': '$value',
                        },
                        'tdcAmount',
                      ],
                    },
                  ],
                },
              },
              mtdcAmount: {
                '+': {
                  '->': [
                    {
                      '@': 'projectGlExpenseAmounts',
                    },
                    {
                      '@>': [
                        {
                          '@$': '$value',
                        },
                        'mtdcAmount',
                      ],
                    },
                  ],
                },
              },
            },
          },
          subqueries: {
            projectGlExpenseAmounts: {
              ref: {
                attr: 'attr:ent#!gl_exp#!entry:!proj',
              },
              target: 'ent:!gl_exp:!entry',
              selection: {
                '{}': {
                  tdcAmount: {
                    '@.': '!amount',
                  },
                  mtdcAmount: {
                    if: [
                      [
                        {
                          '@': 'isInMtdc',
                        },
                        {
                          '@.': '!amount',
                        },
                      ],
                      0,
                    ],
                  },
                },
              },
              subqueries: {
                isInMtdc: {
                  ref: {
                    attr: 'attr:ent#!gl_exp#!entry:!acct',
                  },
                  target: 'ent:!gl_accts:!acct',
                  selection: {
                    '@.': '!is_in_mtdc',
                  },
                },
              },
            },
          },
        },
        orgSpaceAssignments: {
          ref: {
            attr: 'attr:ent#!org_space#!entry:!org',
            inherit: '-',
          },
          target: 'ent:!org_space:!entry',
        },
      },
    },
    '2024_orgs': {
      filter: {
        and: [
          {
            '@$': 'orgEntityId',
          },
          {
            '@$': 'orgRecordId',
          },
          {
            if: [
              [
                {
                  '@$': 'shouldAnalyze',
                },
                {
                  '=': [
                    {
                      '@$': 'shouldAnalyze',
                    },
                    {
                      '@.': '!should_analyze',
                    },
                  ],
                },
              ],
              true,
            ],
          },
          {
            '=': [
              {
                '@_': 'id',
              },
              {
                '@$': 'orgEntityId',
              },
            ],
          },
        ],
      },
      period: {
        $range: {
          end: {
            $date: '12/31/2024',
          },
          start: {
            $date: '01/01/2024',
          },
        },
      },
      target: 'dim::!org',
      selection: {
        '{}': {
          id: {
            '@.': '!id',
          },
          density: {
            if: [
              [
                {
                  '=': [
                    {
                      '@>': 'totalAsf',
                    },
                    0,
                  ],
                },
                0,
              ],
              {
                '/': [
                  {
                    '@>': 'projectsExpenses',
                  },
                  {
                    '@>': 'totalAsf',
                  },
                ],
              },
            ],
          },
          totalAsf: {
            '??': [
              {
                '+': {
                  '->': [
                    {
                      '@': 'rooms',
                    },
                    {
                      '@>': [
                        {
                          '@$': '$value',
                        },
                        'asf',
                      ],
                    },
                  ],
                },
              },
              0,
            ],
          },
          tdcAmount: {
            '??': [
              {
                '+': {
                  '->': [
                    {
                      '@': 'projectsExpenses',
                    },
                    {
                      '@>': [
                        {
                          '@$': '$value',
                        },
                        'tdcAmount',
                      ],
                    },
                  ],
                },
              },
              0,
            ],
          },
          totalSqft: {
            '??': [
              {
                '+': {
                  '->': [
                    {
                      '@': 'rooms',
                    },
                    {
                      '@>': [
                        {
                          '@$': '$value',
                        },
                        'sqft',
                      ],
                    },
                  ],
                },
              },
              0,
            ],
          },
          isSelected: {
            if: [
              [
                {
                  '=': [
                    {
                      '@.': '!id',
                    },
                    {
                      '@$': 'orgRecordId',
                    },
                  ],
                },
                1,
              ],
              0,
            ],
          },
          mtdcAmount: {
            '??': [
              {
                '+': {
                  '->': [
                    {
                      '@': 'projectsExpenses',
                    },
                    {
                      '@>': [
                        {
                          '@$': '$value',
                        },
                        'mtdcAmount',
                      ],
                    },
                  ],
                },
              },
              0,
            ],
          },
          utilization: {
            if: [
              [
                {
                  '=': [
                    {
                      '@>': 'totalSqft',
                    },
                    0,
                  ],
                },
                0,
              ],
              {
                '/': [
                  {
                    '@>': 'totalAsf',
                  },
                  {
                    '@>': 'totalSqft',
                  },
                ],
              },
            ],
          },
          projectsExpenses: {
            if: [
              [
                {
                  '=': [
                    {
                      '@$': 'financialVolume',
                    },
                    'MTDC',
                  ],
                },
                {
                  '@>': 'mtdcAmount',
                },
              ],
              {
                '@>': 'tdcAmount',
              },
            ],
          },
          selectedOrgDensity: {
            '*': [
              {
                '@>': 'density',
              },
              {
                '@>': 'isSelected',
              },
            ],
          },
          selectedOrgUtilization: {
            '*': [
              {
                '@>': 'utilization',
              },
              {
                '@>': 'isSelected',
              },
            ],
          },
          useForComputeAvgDensity: {
            if: [
              [
                {
                  '!=': [
                    {
                      '@>': 'totalAsf',
                    },
                    0,
                  ],
                },
                1,
              ],
              0,
            ],
          },
          selectedOrgProjectsExpenses: {
            '*': [
              {
                '@>': 'projectsExpenses',
              },
              {
                '@>': 'isSelected',
              },
            ],
          },
          useForComputeAvgUtilization: {
            if: [
              [
                {
                  '!=': [
                    {
                      '@>': 'totalSqft',
                    },
                    0,
                  ],
                },
                1,
              ],
              0,
            ],
          },
        },
      },
      subqueries: {
        rooms: {
          ref: {
            attr: 'attr:ent#!org_space#!entry:!space',
          },
          using: 'orgSpaceAssignments',
          filter: {
            or: [
              {
                '=': [
                  {
                    '@$': 'spaceType',
                  },
                  null,
                ],
              },
              {
                in: [
                  {
                    '@.': [
                      '!space_use',
                      {
                        ref: {
                          entity: '!group',
                        },
                      },
                    ],
                  },
                  {
                    '@>': [
                      {
                        '@$': 'spaceType',
                      },
                      'ent:!space_use:!group',
                    ],
                  },
                ],
              },
            ],
          },
          target: 'ent:!space:!room',
          selection: {
            '{}': {
              asf: {
                '*': [
                  {
                    '@.': '!sqft',
                  },
                  {
                    '/': [
                      {
                        '+': {
                          '->': [
                            {
                              '@': 'weights',
                            },
                            {
                              '*': [
                                {
                                  '@>': [
                                    {
                                      '@$': '$value',
                                    },
                                    'value',
                                  ],
                                },
                                {
                                  '@>': [
                                    {
                                      '@$': '$value',
                                    },
                                    'allowable',
                                  ],
                                },
                              ],
                            },
                          ],
                        },
                      },
                      {
                        '+': {
                          '->': [
                            {
                              '@': 'weights',
                            },
                            {
                              '@>': [
                                {
                                  '@$': '$value',
                                },
                                'value',
                              ],
                            },
                          ],
                        },
                      },
                    ],
                  },
                ],
              },
              sqft: {
                '@.': '!sqft',
              },
            },
          },
          subqueries: {
            weights: {
              ref: {
                attr: 'attr:ent#!space_funcl#!entry:!space',
                inherit: '-',
              },
              filter: {
                '!=': [
                  {
                    '@.': '!weight',
                  },
                  0,
                ],
              },
              target: 'ent:!space_funcl:!entry',
              selection: {
                '{}': {
                  value: {
                    '@.': '!weight',
                  },
                  allowable: {
                    if: [
                      [
                        {
                          '!=': [
                            {
                              '@': 'funcIdCat',
                            },
                            null,
                          ],
                        },
                        1,
                      ],
                      0,
                    ],
                  },
                },
              },
              subqueries: {
                funcIdCat: {
                  ref: {
                    attr: 'attr:ent#!space_funcl#!entry:!func_space',
                  },
                  target: 'ent:!func_space:!func',
                  selection: {
                    '@.': [
                      '!func_idc',
                      {
                        ref: {
                          entity: '!cat',
                        },
                      },
                    ],
                  },
                },
              },
            },
          },
        },
        projectsExpenses: {
          ref: {
            attr: 'attr:ent#!projects#!proj:!org',
            inherit: '-',
          },
          filter: {
            and: [
              {
                not: {
                  '=': [
                    {
                      '@': 'projectGlExpenseAmounts',
                    },
                    null,
                  ],
                },
              },
              {
                or: [
                  {
                    '=': [
                      {
                        '@$': 'researchType',
                      },
                      null,
                    ],
                  },
                  {
                    '=': [
                      {
                        '#': {
                          '@$': 'researchType',
                        },
                      },
                      0,
                    ],
                  },
                  {
                    in: [
                      {
                        '@.': '!research_type_wfuhs',
                      },
                      {
                        '@$': 'researchType',
                      },
                    ],
                  },
                ],
              },
            ],
          },
          target: 'ent:!projects:!proj',
          selection: {
            '{}': {
              tdcAmount: {
                '+': {
                  '->': [
                    {
                      '@': 'projectGlExpenseAmounts',
                    },
                    {
                      '@>': [
                        {
                          '@$': '$value',
                        },
                        'tdcAmount',
                      ],
                    },
                  ],
                },
              },
              mtdcAmount: {
                '+': {
                  '->': [
                    {
                      '@': 'projectGlExpenseAmounts',
                    },
                    {
                      '@>': [
                        {
                          '@$': '$value',
                        },
                        'mtdcAmount',
                      ],
                    },
                  ],
                },
              },
            },
          },
          subqueries: {
            projectGlExpenseAmounts: {
              ref: {
                attr: 'attr:ent#!gl_exp#!entry:!proj',
              },
              target: 'ent:!gl_exp:!entry',
              selection: {
                '{}': {
                  tdcAmount: {
                    '@.': '!amount',
                  },
                  mtdcAmount: {
                    if: [
                      [
                        {
                          '@': 'isInMtdc',
                        },
                        {
                          '@.': '!amount',
                        },
                      ],
                      0,
                    ],
                  },
                },
              },
              subqueries: {
                isInMtdc: {
                  ref: {
                    attr: 'attr:ent#!gl_exp#!entry:!acct',
                  },
                  target: 'ent:!gl_accts:!acct',
                  selection: {
                    '@.': '!is_in_mtdc',
                  },
                },
              },
            },
          },
        },
        orgSpaceAssignments: {
          ref: {
            attr: 'attr:ent#!org_space#!entry:!org',
            inherit: '-',
          },
          target: 'ent:!org_space:!entry',
        },
      },
    },
    '2023_rooms': {
      filter: {
        and: [
          {
            '=': [
              {
                '@$': 'piRecordId',
              },
              null,
            ],
          },
          {
            or: [
              {
                '=': [
                  {
                    '@$': 'orgRecordId',
                  },
                  null,
                ],
              },
              {
                '=': [
                  {
                    '@$': 'orgEntityId',
                  },
                  null,
                ],
              },
            ],
          },
          {
            or: [
              {
                '=': [
                  {
                    '@$': 'spaceType',
                  },
                  null,
                ],
              },
              {
                in: [
                  {
                    '@.': [
                      '!space_use',
                      {
                        ref: {
                          entity: '!group',
                        },
                      },
                    ],
                  },
                  {
                    '@>': [
                      {
                        '@$': 'spaceType',
                      },
                      'ent:!space_use:!group',
                    ],
                  },
                ],
              },
            ],
          },
          {
            if: [
              [
                {
                  '@$': 'shouldAnalyze',
                },
                {
                  in: [
                    true,
                    {
                      '@': 'shouldAnalyze',
                    },
                  ],
                },
              ],
              true,
            ],
          },
        ],
      },
      period: {
        $range: {
          end: {
            $date: '12/31/2023',
          },
          start: {
            $date: '01/01/2023',
          },
        },
      },
      target: 'ent:!space:!room',
      selection: {
        '{}': {
          asf: {
            '*': [
              {
                '@.': '!sqft',
              },
              {
                '/': [
                  {
                    '+': {
                      '->': [
                        {
                          '@': 'weights',
                        },
                        {
                          '*': [
                            {
                              '@>': [
                                {
                                  '@$': '$value',
                                },
                                'value',
                              ],
                            },
                            {
                              '@>': [
                                {
                                  '@$': '$value',
                                },
                                'allowable',
                              ],
                            },
                          ],
                        },
                      ],
                    },
                  },
                  {
                    '+': {
                      '->': [
                        {
                          '@': 'weights',
                        },
                        {
                          '@>': [
                            {
                              '@$': '$value',
                            },
                            'value',
                          ],
                        },
                      ],
                    },
                  },
                ],
              },
            ],
          },
          sqft: {
            '@.': '!sqft',
          },
        },
      },
      subqueries: {
        weights: {
          ref: {
            attr: 'attr:ent#!space_funcl#!entry:!space',
            inherit: '-',
          },
          filter: {
            '!=': [
              {
                '@.': '!weight',
              },
              0,
            ],
          },
          target: 'ent:!space_funcl:!entry',
          selection: {
            '{}': {
              value: {
                '@.': '!weight',
              },
              allowable: {
                if: [
                  [
                    {
                      '!=': [
                        {
                          '@': 'funcIdCat',
                        },
                        null,
                      ],
                    },
                    1,
                  ],
                  0,
                ],
              },
            },
          },
          subqueries: {
            funcIdCat: {
              ref: {
                attr: 'attr:ent#!space_funcl#!entry:!func_space',
              },
              target: 'ent:!func_space:!func',
              selection: {
                '@.': [
                  '!func_idc',
                  {
                    ref: {
                      entity: '!cat',
                    },
                  },
                ],
              },
            },
          },
        },
        roomOrgs: {
          ref: {
            attr: 'attr:ent#!org_space#!entry:!space',
          },
          target: 'ent:!org_space:!entry',
        },
        shouldAnalyze: {
          ref: {
            attr: 'attr:ent#!org_space#!entry:!org',
          },
          using: 'roomOrgs',
          target: 'ent:!org:!dept',
          selection: {
            '@.': '!should_analyze',
          },
        },
      },
    },
    '2024_rooms': {
      filter: {
        and: [
          {
            '=': [
              {
                '@$': 'piRecordId',
              },
              null,
            ],
          },
          {
            or: [
              {
                '=': [
                  {
                    '@$': 'orgRecordId',
                  },
                  null,
                ],
              },
              {
                '=': [
                  {
                    '@$': 'orgEntityId',
                  },
                  null,
                ],
              },
            ],
          },
          {
            or: [
              {
                '=': [
                  {
                    '@$': 'spaceType',
                  },
                  null,
                ],
              },
              {
                in: [
                  {
                    '@.': [
                      '!space_use',
                      {
                        ref: {
                          entity: '!group',
                        },
                      },
                    ],
                  },
                  {
                    '@>': [
                      {
                        '@$': 'spaceType',
                      },
                      'ent:!space_use:!group',
                    ],
                  },
                ],
              },
            ],
          },
          {
            if: [
              [
                {
                  '@$': 'shouldAnalyze',
                },
                {
                  in: [
                    true,
                    {
                      '@': 'shouldAnalyze',
                    },
                  ],
                },
              ],
              true,
            ],
          },
        ],
      },
      period: {
        $range: {
          end: {
            $date: '12/31/2024',
          },
          start: {
            $date: '01/01/2024',
          },
        },
      },
      target: 'ent:!space:!room',
      selection: {
        '{}': {
          asf: {
            '*': [
              {
                '@.': '!sqft',
              },
              {
                '/': [
                  {
                    '+': {
                      '->': [
                        {
                          '@': 'weights',
                        },
                        {
                          '*': [
                            {
                              '@>': [
                                {
                                  '@$': '$value',
                                },
                                'value',
                              ],
                            },
                            {
                              '@>': [
                                {
                                  '@$': '$value',
                                },
                                'allowable',
                              ],
                            },
                          ],
                        },
                      ],
                    },
                  },
                  {
                    '+': {
                      '->': [
                        {
                          '@': 'weights',
                        },
                        {
                          '@>': [
                            {
                              '@$': '$value',
                            },
                            'value',
                          ],
                        },
                      ],
                    },
                  },
                ],
              },
            ],
          },
          sqft: {
            '@.': '!sqft',
          },
        },
      },
      subqueries: {
        weights: {
          ref: {
            attr: 'attr:ent#!space_funcl#!entry:!space',
            inherit: '-',
          },
          filter: {
            '!=': [
              {
                '@.': '!weight',
              },
              0,
            ],
          },
          target: 'ent:!space_funcl:!entry',
          selection: {
            '{}': {
              value: {
                '@.': '!weight',
              },
              allowable: {
                if: [
                  [
                    {
                      '!=': [
                        {
                          '@': 'funcIdCat',
                        },
                        null,
                      ],
                    },
                    1,
                  ],
                  0,
                ],
              },
            },
          },
          subqueries: {
            funcIdCat: {
              ref: {
                attr: 'attr:ent#!space_funcl#!entry:!func_space',
              },
              target: 'ent:!func_space:!func',
              selection: {
                '@.': [
                  '!func_idc',
                  {
                    ref: {
                      entity: '!cat',
                    },
                  },
                ],
              },
            },
          },
        },
        roomOrgs: {
          ref: {
            attr: 'attr:ent#!org_space#!entry:!space',
          },
          target: 'ent:!org_space:!entry',
        },
        shouldAnalyze: {
          ref: {
            attr: 'attr:ent#!org_space#!entry:!org',
          },
          using: 'roomOrgs',
          target: 'ent:!org:!dept',
          selection: {
            '@.': '!should_analyze',
          },
        },
      },
    },
    '2023_projectsGlExpenses': {
      filter: {
        and: [
          {
            '=': [
              {
                '@$': 'piRecordId',
              },
              null,
            ],
          },
          {
            or: [
              {
                '=': [
                  {
                    '@$': 'orgRecordId',
                  },
                  null,
                ],
              },
              {
                '=': [
                  {
                    '@$': 'orgEntityId',
                  },
                  null,
                ],
              },
            ],
          },
          {
            or: [
              {
                '=': [
                  {
                    '@$': 'researchType',
                  },
                  null,
                ],
              },
              {
                '=': [
                  {
                    '#': {
                      '@$': 'researchType',
                    },
                  },
                  0,
                ],
              },
              {
                in: [
                  {
                    '@.': '!research_type_wfuhs',
                  },
                  {
                    '@$': 'researchType',
                  },
                ],
              },
            ],
          },
          {
            if: [
              [
                {
                  '@$': 'shouldAnalyze',
                },
                {
                  '=': [
                    {
                      '@$': 'shouldAnalyze',
                    },
                    {
                      '@': 'shouldAnalyze',
                    },
                  ],
                },
              ],
              true,
            ],
          },
        ],
      },
      period: {
        $range: {
          end: {
            $date: '12/31/2023',
          },
          start: {
            $date: '1/1/2023',
          },
        },
      },
      target: 'ent:!projects:!proj',
      selection: {
        '{}': {
          tdcAmount: {
            '+': {
              '->': [
                {
                  '@': 'glExpenses',
                },
                {
                  '@>': [
                    {
                      '@$': '$value',
                    },
                    'tdcAmount',
                  ],
                },
              ],
            },
          },
          mtdcAmount: {
            '+': {
              '->': [
                {
                  '@': 'glExpenses',
                },
                {
                  '@>': [
                    {
                      '@$': '$value',
                    },
                    'mtdcAmount',
                  ],
                },
              ],
            },
          },
        },
      },
      subqueries: {
        glExpenses: {
          ref: {
            attr: 'attr:ent#!gl_exp#!entry:!proj',
          },
          target: 'ent:!gl_exp:!entry',
          selection: {
            '{}': {
              tdcAmount: {
                '@.': '!amount',
              },
              mtdcAmount: {
                if: [
                  [
                    {
                      '@': 'isInMtdc',
                    },
                    {
                      '@.': '!amount',
                    },
                  ],
                  0,
                ],
              },
            },
          },
          subqueries: {
            isInMtdc: {
              ref: {
                attr: 'attr:ent#!gl_exp#!entry:!acct',
              },
              target: 'ent:!gl_accts:!acct',
              selection: {
                '@.': '!is_in_mtdc',
              },
            },
          },
        },
        shouldAnalyze: {
          ref: {
            attr: 'attr:ent#!projects#!proj:!org',
          },
          target: 'ent:!org:!dept',
          selection: {
            '@.': '!should_analyze',
          },
        },
      },
    },
    '2024_projectsGlExpenses': {
      filter: {
        and: [
          {
            '=': [
              {
                '@$': 'piRecordId',
              },
              null,
            ],
          },
          {
            or: [
              {
                '=': [
                  {
                    '@$': 'orgRecordId',
                  },
                  null,
                ],
              },
              {
                '=': [
                  {
                    '@$': 'orgEntityId',
                  },
                  null,
                ],
              },
            ],
          },
          {
            or: [
              {
                '=': [
                  {
                    '@$': 'researchType',
                  },
                  null,
                ],
              },
              {
                '=': [
                  {
                    '#': {
                      '@$': 'researchType',
                    },
                  },
                  0,
                ],
              },
              {
                in: [
                  {
                    '@.': '!research_type_wfuhs',
                  },
                  {
                    '@$': 'researchType',
                  },
                ],
              },
            ],
          },
          {
            if: [
              [
                {
                  '@$': 'shouldAnalyze',
                },
                {
                  '=': [
                    {
                      '@$': 'shouldAnalyze',
                    },
                    {
                      '@': 'shouldAnalyze',
                    },
                  ],
                },
              ],
              true,
            ],
          },
        ],
      },
      period: {
        $range: {
          end: {
            $date: '12/31/2024',
          },
          start: {
            $date: '1/1/2024',
          },
        },
      },
      target: 'ent:!projects:!proj',
      selection: {
        '{}': {
          tdcAmount: {
            '+': {
              '->': [
                {
                  '@': 'glExpenses',
                },
                {
                  '@>': [
                    {
                      '@$': '$value',
                    },
                    'tdcAmount',
                  ],
                },
              ],
            },
          },
          mtdcAmount: {
            '+': {
              '->': [
                {
                  '@': 'glExpenses',
                },
                {
                  '@>': [
                    {
                      '@$': '$value',
                    },
                    'mtdcAmount',
                  ],
                },
              ],
            },
          },
        },
      },
      subqueries: {
        glExpenses: {
          ref: {
            attr: 'attr:ent#!gl_exp#!entry:!proj',
          },
          target: 'ent:!gl_exp:!entry',
          selection: {
            '{}': {
              tdcAmount: {
                '@.': '!amount',
              },
              mtdcAmount: {
                if: [
                  [
                    {
                      '@': 'isInMtdc',
                    },
                    {
                      '@.': '!amount',
                    },
                  ],
                  0,
                ],
              },
            },
          },
          subqueries: {
            isInMtdc: {
              ref: {
                attr: 'attr:ent#!gl_exp#!entry:!acct',
              },
              target: 'ent:!gl_accts:!acct',
              selection: {
                '@.': '!is_in_mtdc',
              },
            },
          },
        },
        shouldAnalyze: {
          ref: {
            attr: 'attr:ent#!projects#!proj:!org',
          },
          target: 'ent:!org:!dept',
          selection: {
            '@.': '!should_analyze',
          },
        },
      },
    },
  },
}
